<template>
  <div class="home-page container-md">
    <h2>Modal 对话框</h2>
    <p>模态对话框。</p>

    <h4>何时使用</h4>
    <p>需要用户处理事务，又不希望跳转页面以致打断工作流程时，可以使用 Modal 在当前页面正中打开一个浮层，承载相应的操作。</p>

    <h4>演示</h4>
    <button class="btn btn-primary btn-large" @click.prevent="isShow = true">点击显示</button>
    <modal title="漂亮的对话框" content="你可以选择确认或者取消欧"
      @modal-on-close="isShow = false"
      @modal-on-confirm="confirm"
      :visible="isShow"
    >
    </modal>
    <h4 class="mt-4">代码</h4>
    <pre class="language-html">
      <code v-html="highlightedCode"></code>
    </pre>
    <h4>Loader 属性和事件</h4>
    <props-table :props="props"></props-table>
  </div>
</template>

<script>
import Prism from 'prismjs'
import Modal from '../components/Modal.vue'
import PropsTable from '../components/PropsTable.vue'
export default {
  data () {
    return {
      isShow: false,
      props: [
        { name: 'title', type: 'string', desc: 'Modal 的标题' },
        { name: 'content', type: 'string', desc: 'Modal 的内容' },
        { name: 'visible', type: 'boolean', desc: '是否可见', default: 'false' },
        { name: 'modal-on-close', type: '事件', desc: '回调 () => void, 点击确认的时候触发' },
        { name: 'modal-on-confirm', type: '事件', desc: '回调 () => void, 点击取消的时候触发' }
      ],
      code: `
    <button class="btn btn-primary btn-large" @click.prevent="isShow = true">点击显示</button>
    <modal title="漂亮的对话框" content="你可以选择确认或者取消欧"
      @modal-on-close="isShow = false"
      @modal-on-confirm="confirm"
      :visible="isShow"
    >
    </modal>`
    }
  },
  computed: {
    highlightedCode () {
      return Prism.highlight(this.code, Prism.languages.html)
    }
  },
  components: {
    Modal,
    PropsTable
  },
  methods: {
    confirm () {
      alert('你点击了确认欧')
      this.isShow = false
    }
  }
}
</script>
